import { DownloadOutlined, ProfileOutlined } from '@ant-design/icons';
import { useTranslate } from '@tolgee/react';
import { Button, message, Modal, ModalProps, Spin, Upload } from 'antd';
import { useState } from 'react';
import ImportMaliciousBuyerHistoryModal from './ImportMaliciousBuyerHistoryModal';
import { importMaliciousBuyer } from './service';
import styled from '@emotion/styled';
import { useSystemLanguageValue } from 'hooks/business/system/useSystem';

function ImportMaliciousBuyerModal({
  onImport,
  ...otherProps
}: ModalProps & {
  onImport: () => any;
}) {
  const { t } = useTranslate();

  const lang = useSystemLanguageValue();

  const [loading, setLoading] = useState(false);

  const [visible, setVisible] = useState(false);

  const [refreshKey, setRefreshKey] = useState(0);

  const historyModal = (
    <ImportMaliciousBuyerHistoryModal
      refreshKey={refreshKey}
      visible={visible}
      onCancel={() => setVisible(false)}
    />
  );

  return (
    <Modal width={800} title={t('导入恶意买家')} footer={false} {...otherProps}>
      <Container>
        <Button
          type="link"
          icon={<DownloadOutlined />}
          target="__blank"
          href={
            {
              'zh-CN':
                'https://oversea-public-1252160878.cos.ap-nanjing.myqcloud.com/malbuyerexcel/恶意买家导入模板.xlsx',
              'en-US':
                'https://oversea-public-1252160878.cos.ap-nanjing.myqcloud.com/malbuyerexcel/Import template - en.xlsx',
              id: 'https://oversea-public-1252160878.cos.ap-nanjing.myqcloud.com/malbuyerexcel/Template impor - id.xlsx',
              th: 'https://oversea-public-1252160878.cos.ap-nanjing.myqcloud.com/malbuyerexcel/เทมเพลตการนำเข้า - th.xlsx',
              tl: 'https://oversea-public-1252160878.cos.ap-nanjing.myqcloud.com/malbuyerexcel/Reason for import failure - tl.xlsx',
              es: 'https://oversea-public-1252160878.cos.ap-nanjing.myqcloud.com/malbuyerexcel/Import template - en.xlsx',
              vi: 'https://oversea-public-1252160878.cos.ap-nanjing.myqcloud.com/malbuyerexcel/Ma%CC%82%CC%83u%20nha%CC%A3%CC%82%20-%20vn.xlsx',
              pt: 'https://oversea-public-1252160878.cos.ap-nanjing.myqcloud.com/malbuyerexcel/Modelo%20de%20Importac%CC%A7a%CC%83o%20-%20pt.xlsx',
            }[lang]
          }
        >
          {t('aide.下载模版')}
        </Button>
        <Button type="text" icon={<ProfileOutlined />} onClick={() => setVisible(true)}>
          {t('trade.操作记录')}
        </Button>
        {historyModal}
      </Container>
      <Spin spinning={loading}>
        <Upload.Dragger
          accept=".xlsx,.xls"
          showUploadList={false}
          customRequest={({ file }) => {
            setLoading(true);
            importMaliciousBuyer(file as any)
              .then(({ failNum, successNum }) => {
                if (failNum > 0) {
                  message.warn(t('未查询到订单号'));
                } else if (successNum > 0) {
                  message.success(t('导入成功'));
                  otherProps.onCancel?.({} as any);
                } else {
                  return message.error(t('未查询到订单号'));
                }
                onImport();
                setRefreshKey(refreshKey + 1);
              })
              .catch(() => {
                message.error(t('phrase.上传失败'));
              })
              .finally(() => {
                setLoading(false);
              });
            return Upload.LIST_IGNORE;
          }}
        >
          <p className="ant-upload-text" style={{ color: 'var(--ant-primary-color)' }}>
            {t('点击或者将文件拖拽到此区域上传')}
          </p>
          <p className="ant-upload-hint">{t('限一个文件，文件拓展名为xlsx.xls')}</p>
        </Upload.Dragger>
      </Spin>
    </Modal>
  );
}

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: -12px;
  > a,
  button {
    padding: 0;
  }
`;

export default ImportMaliciousBuyerModal;
